const mediaUrls = {
  'wazai-media-message': 'https://media-message.wazai.com.br',
  'storage': 'https://storage.wazai.com.br',
}

export function getMediaUrlByMediaKey(mediaKey: string) {
  const [type, id] = mediaKey.split('_');

  if (!type || !id) {
    throw new Error('Invalid media key');
  }

  return `${mediaUrls[type as keyof typeof mediaUrls]}/${mediaKey}`;
}